<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            Companies that can access {{ influencer.instagramHandle }}
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-9">
              <select id="select" class="form-control select2" name="state" v-model="addCompanyID">
                <option disabled value="">Assign a company to influencer</option>
                <option v-for="option in company_options" v-bind:value="option.id" :key="option.id">
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-xs-3">
              <!-- Assign button -->
              <b-button variant="primary" class="col-xs-12" @click.stop="assignCompany()">
                Assign
              </b-button>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12">
              <b-table striped bordered hover responsive :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="items" :fields="fields">
                <template v-slot:cell(actions)="row">
                  <!-- Delete button -->
                  <b-button variant="danger" size="sm" @click.stop="unassignCompany(row.item.id)">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
          <!-- Pagination -->
          <div class="row">
            <div class="col-xs-12">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" size="sm" align="center" />
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default text--secondary" data-dismiss="modal" ref="closeButton">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyAPIs from '../Company/companyAPIs'
import influencerAPIs from './influencerAPIs'

export default {
  name: 'ViewInfluencerCompanyModal',
  props: ['modalId', 'influencerData'],
  data() {
    return {
      influencer: {},
      addCompanyID: '',
      company_options: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { key: 'name', sortable: true },
        { key: 'address', sortable: true },
        { key: 'website', sortable: true },
        { key: 'phoneNumber', sortable: true },
        { key: 'actions', sortable: false }
      ],
      items: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null
    }
  },
  computed: {
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    }
  },
  watch: {
    influencerData: function(newInfluencerData) {
      this.influencer = newInfluencerData
      this.refreshCompanyList()
    }
  },
  methods: {
    assignCompany: function() {
      if (this.addCompanyID) {
        influencerAPIs
          .assignCompany(this.influencer.id, this.addCompanyID)
          .then(response => {
            this.refreshCompanyList()
            this.addCompanyID = ''
          })
          .catch(error => {
            // Request failed.
            console.log('error', error)
          })
      }
    },
    unassignCompany: function(companyID) {
      influencerAPIs
        .unassignCompany(this.influencer.id, companyID)
        .then(response => {
          this.refreshCompanyList()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    refreshCompanyList: function() {
      influencerAPIs
        .getInfluencerCompany(this.influencer.id)
        .then(response => {
          // Update company list table
          this.items = response.companies
          this.totalRows = this.items.length

          companyAPIs
            .getAllCompanies(false)
            .then(response => {
              this.company_options = response.data

              // Filter company list
              const displayCompanyListID = this.items.map(company => {
                return company.id
              })

              this.company_options = this.company_options.filter(company => {
                return !displayCompanyListID.includes(company.id)
              })
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)
            })
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// ViewInfluencerCompanyModal.vue?7505a382